import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["CasesGrid"] */ "/vercel/path0/src/app/(site)/referenzen/CasesGrid.tsx");
